import { cleanAPI } from './config';

export interface MinAppVersion {
  mandatory_version: string;
  /** E3 — newest available version; running below it → dismissible update popin. */
  latest_version: string;
}

/**
 * Fetch the backend's minimum required app version (#4) and the latest
 * available one (E3). Public endpoint — uses the clean axios instance
 * (no auth) so the gate can run pre-login.
 */
export const getMinAppVersion = async (): Promise<MinAppVersion> => {
  const response = await cleanAPI.get<{ data: MinAppVersion | null }>('/min-app-version');
  return {
    mandatory_version: response.data.data?.mandatory_version ?? '',
    latest_version: response.data.data?.latest_version ?? '',
  };
};
